import { format as formatter } from 'date-fns'
import type { VFC } from 'react'
import * as styles from './styles'
import type { TimestampProps } from './types'

export const Timestamp: VFC<TimestampProps> = ({
  format = 'PPP, p',
  messageIfMissing = 'No timestamp available',
  styleOverrides,
  theme = 'light',
  timestamp,
}) => (
  <time
    css={[styles.container({ theme }), styleOverrides]}
    dateTime={
      timestamp && Object.prototype.toString.call(timestamp) === '[object Date]'
        ? timestamp.toISOString()
        : undefined
    }
  >
    {timestamp && Object.prototype.toString.call(timestamp) === '[object Date]'
      ? formatter(timestamp, format)
      : messageIfMissing}
  </time>
)
Timestamp.displayName = 'Kuiper: Timestamp'
